._messageWrapperInlineIcon_12uno_1 {
  vertical-align: middle;
}